import React, { Fragment } from "react";
import styled from "styled-components";
import { Grid } from "@material-ui/core";
import { IntegerInput } from "components/Global/FormikMaterial";

const MinWidthGrid = styled(Grid)`
  &&&& {
    min-width: ${props => props.minWidth}px;
    padding-bottom:15px;

  }
`;
const StyledIntegerInput = styled(IntegerInput)`
  & {width:100%;}
`;
const MortgageStyleAmortVariant = ({ }) => (
  <>
    <MinWidthGrid container alignItems="center" item xs={12} sm={3} md={3} lg={3} xl={3} minWidth={140}>
      <StyledIntegerInput
        label="Amort Term (m)"
        fieldName="amortizationTerm"
      />
    </MinWidthGrid>
    <MinWidthGrid item xs={12} sm={2} md={2} lg={2} xl={2} minWidth={100}>
      <StyledIntegerInput
        label="I/O Period (m)"
        fieldName="interestOnlyPeriod"
      />
    </MinWidthGrid>
  </>
);
export default MortgageStyleAmortVariant;
